enum AppointmentOutcome {
	PLANNED = 'planned',
	COMPLETED = 'completed',
	NOT_COMPLETED = 'notCompleted'
}

export default AppointmentOutcome;
